import { useEffect, useRef } from 'react';
import { io, type Socket } from 'socket.io-client';

import { useAuthStore } from '../stores/auth.js';

const baseURL = import.meta.env.VITE_API_URL ?? window.location.origin;

const sockets = new Map<string, Socket>();

function getOrCreateSocket(namespace: string): Socket {
  const existing = sockets.get(namespace);
  if (existing) {
    return existing;
  }
  const token = useAuthStore.getState().token;
  const socket = io(`${baseURL}${namespace}`, {
    transports: ['websocket'],
    auth: { token },
    autoConnect: true,
  });
  sockets.set(namespace, socket);
  return socket;
}

export function useRealtimeChannel<TPayload = unknown>(args: {
  namespace: '/realtime/tasks' | '/realtime/pipeline';
  event: string;
  handler: (payload: TPayload) => void;
}): void {
  const handlerRef = useRef(args.handler);
  handlerRef.current = args.handler;

  useEffect(() => {
    const socket = getOrCreateSocket(args.namespace);
    const wrapped = (payload: TPayload): void => handlerRef.current(payload);
    socket.on(args.event, wrapped);
    return () => {
      socket.off(args.event, wrapped);
    };
  }, [args.namespace, args.event]);
}

/** Encerra todas as conexões — chamar no logout. */
export function disconnectAllRealtime(): void {
  for (const s of sockets.values()) {
    s.disconnect();
  }
  sockets.clear();
}
